import * as React from "react";
import { Container, Stack, styled } from "@mui/material";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { company, gradientColor } from "./constants";

const drawerWidth = 240;

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const handleScroll = () => {
        if (window.scrollY > 0) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [window]);

  const logostyle = {
    background: gradientColor,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "800 !important",
    fontSize: {
      sm: "1.5rem",
      md: "2rem",
      xs: "1.5rem ",
    },
    display: {
      xs: "none",
      md: "block",
    },
    cursor: "pointer",
    textTransform: "capitalize",
  };
  const mobileLogostyle = {
    background: gradientColor,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "800 !important",

    fontSize: {
      sm: "1.5rem",
      md: "2rem",
      xs: "1.5rem ",
    },
    display: {
      xs: "block",
      md: "none",
    },
    cursor: "pointer",
    textTransform: "capitalize",
  };

  const Navbtns = styled(Button)({
    margin: "0 20px !important",
    textAlign: "center",
    textTransform: "capitalize ",
    fontSize: "1em",
    color: "#333338",
    fontWeight: "500",
    "&:hover": {
      background: gradientColor,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      bottom: 0,
      height: "2px",
      width: 0,
      background: "#87c5a4",
      transition: "width 0.3s ease",
    },
    "&:hover::after": {
      width: "100%",
    },
  });

  const ContactUs = styled(Button)({
    fontWeight: "700",
    fontSize: "0.85rem",
    width: "fit-content",
    color: "white",
    borderRadius: "20px",
    backgroundColor: "#0a1530",
    padding: "5px 15px",
    transition: "background 2s ease",
    textAlign: "center",
    "&:hover": {
      background: gradientColor,
    },
  });

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          my: 2,
          fontWeight: "bold",
          background: gradientColor,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {company.name}
      </Typography>
      <Divider />
      <Box>
        <Navbtns color="inherit" href="#about">
          About Us
        </Navbtns>
        <Navbtns color="inherit" href="#products">
          Products
        </Navbtns>
        <Navbtns color="inherit" href="#certificates">
          Certificates
        </Navbtns>
      </Box>
      <ContactUs color="inherit" href="#contact">
        Contact Us
      </ContactUs>
    </Box>
  );

  const container =
    typeof window !== "undefined" ? () => window().document.body : undefined;

  return (
    <Box
      sx={{
        display: "flex",
        overflow: "hidden",
      }}
    >
      <AppBar
        component="nav"
        sx={{
          background: "transparent",
          backdropFilter: "blur(100px) saturate(200%)",
          boxShadow: isScrolled ? "0px 4px 15px rgba(0, 0, 0, 0.3)" : "none",
          transition: "box-shadow 0.3s ease",
          py: 1,
        }}
      >
        <Stack
          justifyContent="space-between"
          alignItems="center"
          flexDirection="row-reverse"
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              color: "black",
              mr: 2,
              p: 0,
              display: { md: "none" },
            }}
          >
            <MenuIcon />
          </IconButton>
          <Button LinkComponent={"a"} href="/" sx={mobileLogostyle}>
            {company.name}
          </Button>
        </Stack>
        <Container
          sx={{
            display: {
              xs: "none",
              md: "block",
            },
          }}
        >
          <Toolbar
            sx={{
              color: "black",
              alignItems: "center",
              justifyContent: {
                xs: "space-between",
                md: "space-between",
              },
            }}
          >
            <Button LinkComponent={"a"} href="/" sx={logostyle}>
              {company.name}
            </Button>
            <Box
              sx={{
                display: {
                  xs: "none",
                  md: "flex",
                },
                justifyContent: "space-between",
                marginRight: "50px",
              }}
            >
              <Navbtns color="inherit" href="#about">
                About Us
              </Navbtns>
              <Navbtns color="inherit" href="#products">
                Products
              </Navbtns>
              <Navbtns color="inherit" href="#certificates">
                Certificates
              </Navbtns>
            </Box>
            <ContactUs
              sx={{
                marginRight: "50px",
                display: {
                  xs: "none",
                  md: "block",
                },
              }}
              color="inherit"
              href="#contact"
            >
              Contact Us
            </ContactUs>
          </Toolbar>
        </Container>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Box component="main" sx={{ p: 3 }}>
        <Toolbar />
      </Box>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  window: PropTypes.func,
};

export default DrawerAppBar;
